import Vue from "vue";
import Router from "vue-router";
import home from "@/page/home";
import tools from "@/page/tools";
import cases from "@/page/cases";
import cooperate from "@/page/cooperate";
import talents from "@/page/talents";
import about from "@/page/about";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: home,
    },
    {
      path: "/tools",
      name: "tools",
      component: tools,
    },
    {
      path: "/cases",
      name: "cases",
      component: cases,
    },
    {
      path: "/cooperate",
      name: "cooperate",
      component: cooperate,
    },
    {
      path: "/talents",
      name: "talents",
      component: talents,
    },
    {
      path: "/about",
      name: "about",
      component: about,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js